import { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/SiteLayout";
import { Button } from "@/components/ui/button";

const NotFoundPage = ({ language = "fr" }) => {
  const isFr = language === "fr";

  useEffect(() => {
    // Page inexistante : ne jamais l'indexer ni lui laisser une canonical
    let meta = document.querySelector('meta[name="robots"]');
    const created = !meta;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex");
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.remove();
    return () => {
      if (created) meta.remove();
    };
  }, []);
  return (
    <SiteLayout language={language}>
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24 text-center space-y-6">
          <h1 className="text-4xl font-bold text-primary" data-testid="notfound-title">
            {isFr ? "Page introuvable" : "Page not found"}
          </h1>
          <p className="text-muted-foreground" data-testid="notfound-text">
            {isFr
              ? "La page demandée n'existe pas ou a été déplacée."
              : "The page you requested does not exist or has been moved."}
          </p>
          <Button
            asChild
            className="rounded-none uppercase tracking-wider font-bold"
            data-testid="notfound-home-link"
          >
            <Link to={isFr ? "/fr" : "/en"}>{isFr ? "Retour à l'accueil" : "Back to home"}</Link>
          </Button>
        </div>
      </section>
    </SiteLayout>
  );
};

export default NotFoundPage;